import React from 'react'

import {
  DayCard,
  NoAvailabilityBanner,
  SlotsGrid,
  SlotButtonEx,
  TimeZoneNotice,
} from './BookingsPortalPage.styled'

import {Typography} from '~/components/general/typography/Typography'

type DayTimePanelProps = {
  title: string
  selectedDate: string | null
  selectedDateSlots: string[]
  selectedTime: string | null
  onSelectTime: (time: string) => void
  isLoading: boolean
  timeZoneNotice?: string
  noAvailabilityText: string
}

export const DayTimePanel: React.FC<DayTimePanelProps> = ({
  title,
  selectedDate,
  selectedDateSlots,
  selectedTime,
  onSelectTime,
  isLoading,
  timeZoneNotice,
  noAvailabilityText,
}) => (
  <DayCard>
    <Typography weight="bold">{title}</Typography>
    {selectedDate && selectedDateSlots.length === 0 ? (
      <NoAvailabilityBanner>
        <Typography>{noAvailabilityText}</Typography>
      </NoAvailabilityBanner>
    ) : (
      <SlotsGrid>
        {selectedDateSlots.map((slotTime: string) => (
          <SlotButtonEx
            key={slotTime}
            className={selectedTime === slotTime ? 'selected' : ''}
            onClick={() => onSelectTime(slotTime)}
            disabled={isLoading}>
            {slotTime}
          </SlotButtonEx>
        ))}
      </SlotsGrid>
    )}
    <TimeZoneNotice>
      {timeZoneNotice && <Typography size="sm">{timeZoneNotice}</Typography>}
    </TimeZoneNotice>
  </DayCard>
)
